module.exports = __webpack_public_path__ + "img/feedback-wrong.5b5357d0.png";